import React, {
    useState,
    useEffect
}
from "react";

import {
    useParams
}
from "react-router-dom";

import {
    functions
}
from "../../../constants/common-functions";

import MobileHeader
from "../../home/mobile/components/MobileHeader";

import FloorSpacePlan
from "../components/FloorSpacePlan";

import BlockStackBarList
from "../../../components/BlockStackBarList";

import useSpaceOrgDashboardBuilding
from "../hooks/useSpaceOrgDashboardBuilding";

import "./MobileSpaceOrgBuilding.css";


export default function MobileSpaceOrgBuilding()
{

    //--------------------------------------------------------
    // Parameters
    //--------------------------------------------------------

    const facilityId =
        useParams()["facilityId"];


    //--------------------------------------------------------
    // Dashboard Data
    //--------------------------------------------------------

    const {
        topFloors
    } =
        useSpaceOrgDashboardBuilding(
            facilityId
        );


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [buildingName, setBuildingName] =
        useState("");

    const [selectedFloorId, setSelectedFloorId] =
        useState(-1);

    const [selectedFloorName, setSelectedFloorName] =
        useState("");

    const [selectedSpaceId, setSelectedSpaceId] =
        useState(null);

    const [selectedSpaceTypeId, setSelectedSpaceTypeId] =
        useState(null);

    const [showFloors, setShowFloors] =
        useState(false);

    const [showMenu, setShowMenu] =
        useState(false);


    //--------------------------------------------------------
    // Load Building
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/" +
                "spaceorgfacilityloadinitial" +
                "?facilityId=" +
                facilityId,
                handleFacilityResponse
            );
        },
        [
            facilityId
        ]
    );


    //--------------------------------------------------------
    // Facility Response
    //--------------------------------------------------------

    const handleFacilityResponse =
        (obj) =>
        {
            if(
                obj &&
                obj.facilityName
            )
            {
                setBuildingName(
                    obj.facilityName
                );

                setSelectedFloorId(
                    obj.floorId
                );
            }
        };


    //--------------------------------------------------------
    // Resolve Initial Floor Name
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(
                !topFloors ||
                topFloors.length === 0 ||
                selectedFloorId === -1
            )
            {
                return;
            }

            const selectedFloor =
                topFloors.find(
                    (item) =>
                    {
                        return (
                            String(item.id) ===
                            String(selectedFloorId)
                        );
                    }
                );

            if(selectedFloor)
            {
                setSelectedFloorName(
                    selectedFloor.name ||
                    selectedFloor.label ||
                    selectedFloor.title ||
                    ""
                );
            }
        },
        [
            topFloors,
            selectedFloorId
        ]
    );


    //--------------------------------------------------------
    // Floor Selection
    //--------------------------------------------------------

    const handleFloorSelected =
        (floor) =>
        {
            //------------------------------------------------
            // BlockStackBarList currently returns the ID.
            // Keep this tolerant in case we later return
            // the complete floor object.
            //------------------------------------------------

            const floorId =
                typeof floor === "object"
                    ?
                    floor.id
                    :
                    floor;

            setSelectedFloorId(
                floorId
            );

            //------------------------------------------------
            // Find Floor Name
            //------------------------------------------------

            if(
                topFloors &&
                topFloors.length > 0
            )
            {
                const selectedFloor =
                    topFloors.find(
                        (item) =>
                        {
                            return (
                                String(item.id) ===
                                String(floorId)
                            );
                        }
                    );

                if(selectedFloor)
                {
                    setSelectedFloorName(
                        selectedFloor.name ||
                        selectedFloor.label ||
                        selectedFloor.title ||
                        ""
                    );
                }
            }

            //------------------------------------------------
            // Clear Space Selection
            //------------------------------------------------

            setSelectedSpaceId(
                null
            );

            setSelectedSpaceTypeId(
                null
            );

            //------------------------------------------------
            // Close Selector
            //------------------------------------------------

            setShowFloors(
                false
            );
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (
        <div className="mobile-space-building-page">

            {/*--------------------------------------------------
                Header
            --------------------------------------------------*/}

            <MobileHeader
                openMenu={
                    () =>
                        setShowMenu(true)
                }
                openSearch={
                    () =>
                        console.log(
                            "SEARCH"
                        )
                }
            />


            {/*--------------------------------------------------
                Floor Plan
            --------------------------------------------------*/}

            <div className="mobile-space-building-plan">

                {
                    selectedFloorId !== -1 &&
                    (
                        <FloorSpacePlan
                            key={
                                selectedFloorId
                            }
                            floorId={
                                selectedFloorId
                            }
                            colourMode="spaceType"
                            selectedSpaceId={
                                selectedSpaceId
                            }
                            setSelectedSpaceId={
                                setSelectedSpaceId
                            }
                            selectedSpaceTypeId={
                                selectedSpaceTypeId
                            }
                            setSelectedSpaceTypeId={
                                setSelectedSpaceTypeId
                            }
                            onSpaceClick={
                                function(space)
                                {
                                    console.log(
                                        "Selected space",
                                        space
                                    );
                                }
                            }
                        />
                    )
                }


                {/*----------------------------------------------
                    Building Pill
                ----------------------------------------------*/}

                <div className="mobile-space-building-name">

                    <div className="mobile-space-building-name-label">

                        BUILDING

                    </div>

                    <div className="mobile-space-building-name-value">

                        {
                            buildingName ||
                            "Building"
                        }

                    </div>

                </div>


                {/*----------------------------------------------
                    Floor Selector Button
                ----------------------------------------------*/}

                <button
                    className="mobile-space-building-floor-button"
                    type="button"
                    onClick={
                        () =>
                            setShowFloors(
                                !showFloors
                            )
                    }
                >

                    <div className="mobile-space-building-floor-text">

                        <span className="mobile-space-building-floor-label">

                            FLOOR

                        </span>

                        <span className="mobile-space-building-floor-value">

                            {
                                selectedFloorName ||
                                "Select Floor"
                            }

                        </span>

                    </div>

                    <span
                        className={
                            "mobile-space-building-floor-arrow " +
                            (
                                showFloors
                                    ?
                                    "open"
                                    :
                                    ""
                            )
                        }
                    >

                        ▾

                    </span>

                </button>


                {/*----------------------------------------------
                    Floor Selector Panel
                ----------------------------------------------*/}

                {
                    showFloors &&
                    (
                        <>

                            <div
                                className="mobile-space-building-floor-backdrop"
                                onClick={
                                    () =>
                                        setShowFloors(false)
                                }
                            />

                            <div className="mobile-space-building-floor-selector">

                                <div className="mobile-space-building-floor-selector-header">

                                    <div>

                                        <div className="mobile-space-building-floor-selector-title">

                                            Select Floor

                                        </div>

                                        <div className="mobile-space-building-floor-selector-subtitle">

                                            {
                                                buildingName
                                            }

                                        </div>

                                    </div>

                                    <button
                                        type="button"
                                        className="mobile-space-building-floor-close"
                                        onClick={
                                            () =>
                                                setShowFloors(false)
                                        }
                                    >

                                        ×

                                    </button>

                                </div>


                                <div className="mobile-space-building-floor-list">

                                    {
                                        topFloors &&
                                        topFloors.length > 0
                                            ?
                                            (
                                                <BlockStackBarList
                                                    title=""
                                                    rows={
                                                        topFloors
                                                    }
                                                    onSelect={
                                                        handleFloorSelected
                                                    }
                                                />
                                            )
                                            :
                                            (
                                                <div className="mobile-space-building-no-floors">

                                                    No floors available

                                                </div>
                                            )
                                    }

                                </div>

                            </div>

                        </>
                    )
                }

            </div>

        </div>
    );
}